module.exports = __webpack_public_path__ + "img/ch_gallery_5.5e5916c6.jpg";